// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb-dropdown .dropdown-toggle{padding:.25rem .25rem .25rem .75rem!important}.breadcrumb-dropdown .dropdown-toggle svg{margin-left:1rem}.breadcrumb-dropdown .dropdown-item{padding:.5rem .25rem .5rem .75rem!important}", ""]);
// Exports
module.exports = exports;
